<script lang="ts">
  import { t } from "$lib/i18n/translations";
  import { base } from "$app/paths";
  import GoogleAdSense from "$components/adSense/googleAdSense.svelte";
  import { WEB_SHOW_ADSENCE }from "$env/static/public";
  const cards = [
    {
      title: "general.about.photo.card1.title",
      alt: "general.about.photo.card1.alt",
      description: "general.about.photo.card1.description",
      image: base + "/images/photos-phone.png",
      mobileImage: base + "/images/videos-phone.png",
    },
    {
      title: "general.about.photo.card2.title",
       alt: "general.about.photo.card1.alt",
      description: "general.about.photo.card2.description",
      image: base + "/images/photos-pc.png",
      mobileImage: base + "/images/videos-pc.png",
    },
    {
      title: "general.about.photo.card3.title",
      alt: "general.about.photo.card1.alt",
      description: "general.about.photo.card3.description",
      image: base + "/images/photos-iphone.png",
      mobileImage: base + "/images/videos-iphone.png",
    },
  ];
</script>

<!-- 内容介绍 -->
<section class="w-full bg-[#EAF0FD]">
  <div
    class="max-w-[1312px] mx-auto w-full w-full flex flex-col items-center justify-center px-[16px]"
  >
    <!-- 标题 -->
    <div class="mt-[100px] text-center max-w-[1000px] max-mobile:mt-[40px]">
      <h2
        class="!text-[36px] !font-bold !leading-normal !mb-4 max-mobile:!text-[20px]"
      >
        {$t("general.about.photo.title")}
      </h2>
      <p
        class="!text-[18px] !leading-normal text-[#808080] max-mobile:!text-[14px]"
      >
        {$t("general.about.photo.description")}
      </p>
    </div>

    <div
      class="mt-11 grid grid-cols-1 gap-20 max-w-[1000px] w-full mb-[110px] max-mobile:mt-3 max-mobile:mb-[40px] max-mobile:gap-6"
    >
      {#each cards as card, index}
        <article
          class="bg-white rounded-[16px] flex w-full {index % 2 === 0
            ? 'flex-row'
            : 'flex-row-reverse'} items-center h-[284px] max-mobile:h-full max-mobile:flex-col max-mobile:flex-col-reverse"
        >
          <div
            class="flex-1 shrink-0 w-[50%] leading-[1.5] mx-10 max-mobile:w-full max-mobile:p-4"
          >
            <h3
              class="!text-[24px] !mb-7 max-mobile:!text-[16px] max-mobile:!font-bold max-mobile:!mb-3"
            >
              {$t(card.title)}
            </h3>
            <p
              class="text-[#808080] text-[18px] max-mobile:text-[14px] max-mobile:text-black"
            >
              {$t(card.description)}
            </p>
          </div>
          <div class="grow-1 relative h-full max-mobile:w-full">
            <img
              src={card.image}
              alt={$t(card.alt)}
              class="h-[320px] top-[-18px] object-cover absolute {index % 2 ===
              0
                ? 'right-0'
                : 'left-0'} z-10 max-mobile:hidden"
              loading="lazy"
            />
            <img
              src={card.mobileImage}
              alt={$t(card.title)}
              class="w-full hidden object-cover max-mobile:block"
              loading="lazy"
            />
          </div>
        </article>
      {/each}
    </div>
  </div>
</section>
{#if WEB_SHOW_ADSENCE === "true" }
<section class="w-full max-mobile:bg-[#EAF0FD]">
  <div class="max-w-[1100px] mx-auto w-full w-full my-[100px] max-mobile:my-0">
    <GoogleAdSense type="crosswise"/>
  </div>
</section>
{/if}
